import { AI_PROMPT_TARGET_OBJECTS } from 'constants/aiPrompts';
import { parseDate } from 'lib/date';
import type { Typed } from 'services/api/fields/core';

export interface SummaryOptions {
  title?: string;
  targetClassname?: string;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  [key: string]: any;
}

function getDefaults(): SummaryOptions {
  return {
    id: '',
    title: '',
    targetClassname: '',
    patientName: '',
    client: undefined,
    user: undefined,
    sourcesCount: 0,
    createdAt: undefined,
    updatedAt: undefined,
    attachments: [],
    resultPayload: undefined,
    aiArtifact: undefined,
    aiPrompt: undefined,
    patientDemographics: undefined,
    status: '',
    error: null,
  };
}

// Forward declare so _Summary's constructor can return the infused type
let Summary: new <T extends SummaryOptions>(options: T) => Typed<_Summary<T>, T>;

class _Summary<T extends SummaryOptions = SummaryOptions> {
  targetClassnameApi!: string;
  targetClassname!: string;
  title!: string;
  createdAt!: Date | null;
  updatedAt!: Date | null;

  constructor(options: T) {
    const opts = { ...getDefaults(), ...options };
    Object.assign(this, opts);

    this.targetClassnameApi = opts.targetClassname ?? '';
    this.targetClassname = AI_PROMPT_TARGET_OBJECTS.find(({ id }) => id === this.targetClassnameApi)?.name ?? '';
    this.title = opts.title || this.targetClassname || '';
    this.createdAt = parseDate(opts.createdAt) ?? null;
    this.updatedAt = parseDate(opts.updatedAt) ?? null;
  }
}

Summary = _Summary as typeof Summary; // eslint-disable-line prefer-const

export default Summary;
export { Summary };
export type Summary<T extends SummaryOptions = SummaryOptions> = _Summary<T> & Omit<T, keyof _Summary<T>>;
